import CategoryModule from '@modules/Category';
import PrimaryHeroModule from '@modules/PrimaryHero';
import ParallaxModule from '@modules/Parallax';
import Care from '@modules/Care';
import loadQuiz from '@modules/quiz';
import loadTradeform from '@modules/tradeForm';
import Humankind from '@modules/humankind';
import RewardsTableSlider from '@modules/rewardsTableSlider';
import '../../style/templates/page.scss';
import '../../style/config/yotpo-widgets.scss';
import { pubSub } from '@utils/PubSub';

document.addEventListener('DOMContentLoaded', () => {
  pubSub.broadcast();

  const primaryHeroModule = document.querySelectorAll('.js-primary-hero-module');
  primaryHeroModule.forEach((module) => new PrimaryHeroModule(module));

  const categoryModule = document.querySelectorAll('.js-category-module');
  categoryModule.forEach((module) => new CategoryModule(module));

  const parallaxModule = document.querySelectorAll('.js-parallax-module');
  parallaxModule.forEach((module) => new ParallaxModule(module));

  const careModule = document.querySelectorAll('.js-care-module');
  careModule.forEach((module) => new Care(module));

  new Humankind();

  // Load quiz, trade form and rewards modules on their respective page url
  if (window.location.pathname.includes('quiz')) loadQuiz();
  else if (window.location.pathname.includes('trade')) loadTradeform();
  else if (window.location.pathname.includes('pages/rewards')) {
    setTimeout(() => {
      const yotpoHero = document.querySelector('.yotpo-widget-hero-section'),
        rewardsHeader = document.querySelector('.rewards__header'),
        storyModule = rewardsHeader.querySelector('.story'),
        storyHeadline = rewardsHeader.querySelector('.story__headline'),
        storySubheader = rewardsHeader.querySelector('.story__subhead'),
        customerName = storyModule.dataset.customerName;

      // Sets up story module based on yotpo banner section widget
      if (yotpoHero && rewardsHeader) {
        // update title
        const yotpoTitle = yotpoHero.querySelector('.yotpo-title');
        if (yotpoTitle) storyHeadline.innerHTML = yotpoTitle.innerHTML;
        // description
        storySubheader.innerHTML = yotpoHero.querySelector('.yotpo-description').innerHTML;
        // image
        const yotpoImg = yotpoHero.querySelector('.yotpo-text-on-background').style.backgroundImage,
          yotpoImgSrc = yotpoImg.slice(4, -1).replace(/["']/g, '');
        if (yotpoImgSrc) rewardsHeader.querySelector('.story__media-img').src = yotpoImgSrc;
        // input customer name
        storyHeadline.innerHTML = storyHeadline.innerHTML.replace('{{first_name}}', customerName);
        storyModule.dataset.content = 'widget';
      } else {
        // Fallback
        storyHeadline.innerHTML = `Welcome to the Crew, ${customerName}!`;
        storySubheader.innerHTML = 'Work and daily life are exhausting—finding comfort shouldn&apos;t be. So sit back, relax, and earn more while you shop.';
        storyModule.dataset.content = 'fallback';
      }

      // Customer points & tier details
      const email = document.querySelector('[data-customer]')?.dataset.customer;
      if (email) {
        const pageCurrentPoints = window.Brooklinen.loyalty?.points_balance;
        const pageTier = window.Brooklinen.loyalty?.vip_tier_name;
        let pageTierText = pageTier ? ` <span class="t4" data-color="afternoon-delight-medium">${pageTier}</span> ` : '';
        // Yotpo controlled text
        if (storySubheader.innerHTML.includes('{{current_point_balance}}')) {
          if (storySubheader.innerHTML.includes('{{current_vip_tier_name}}')) {
            storySubheader.innerHTML = storySubheader.innerHTML.replace('{{current_vip_tier_name}}', pageTierText);
          }

          storySubheader.innerHTML = storySubheader.innerHTML.replace('{{current_point_balance}}', `<span class="t4" data-color="afternoon-delight-medium">${pageCurrentPoints}</span>`);
          storySubheader.innerHTML = storySubheader.innerHTML.replace("You're currently a", "<br/> <br/> You're currently a");
        } else {
          // Fallback
          storySubheader.innerHTML += `<br/> <br/> You're currently a ${pageTierText} member with <span class="t4" data-color="afternoon-delight-medium">${pageCurrentPoints}</span> points.`;
        }
      }

      storyModule.classList.remove('hidden');
      rewardsHeader.querySelector('.Stencil').classList.add('hidden');
      document.querySelector('.rewards__widgets').classList.remove('hidden');
    }, 3000);

    // Rewards Tier Table Slider
    const tierSlider = document.querySelector('.tier-compare-mobile');
    new RewardsTableSlider(tierSlider);
  }

  // Load user agent logic
  if (document.querySelector('.module--ua')) {
    const parser = new UAParser();
    const uaRes = parser.getResult();
    delete uaRes.ua;
    delete uaRes.cpu;

    const DYready = setInterval(() => {
      if (typeof DY.Audiences === 'object') {
        uaRes.debug = DY.Audiences.getUserAudiences().join();
        uaRes.device = DY.deviceInfo;
        displayUA();
        clearInterval(DYready);
      }
    }, 100);
    // Stop if over 10 sec
    setTimeout(() => clearInterval(DYready), 10000);

    function displayUA() {
      let uaDisplay = document.querySelector('#uaDisplay');
      let uaJSON = JSON.stringify(uaRes, null, 2);
      uaDisplay.innerHTML = uaJSON;
      uaDisplay.style.height = uaDisplay.scrollHeight + 'px';
    }

    function copyUa() {
      let uaDisplay = document.querySelector('#uaDisplay');
      let uaCta = document.querySelector('#uaCta');
      uaDisplay.select();
      document.execCommand('copy');
      uaCta.innerHTML = 'Copied!';
    }

    function resetUaCta() {
      setTimeout(() => {
        document.querySelector('#uaCta').innerHTML = 'Copy to Clipboard';
      }, 1000);
    }

    document.querySelector('#uaCta').addEventListener('mouseup', copyUa);
    document.querySelector('#uaCta').addEventListener('mouseout', resetUaCta);
  }
});
